import { formatPropertyName } from './format-property-name.js'
import { formatTsValue } from './format-ts-value.js'
export function formatTsObject(value: Record<string, unknown>, indent = 0): string {
  const entries = Object.entries(value)
  if (entries.length === 0) return '{}'

  const childIndent = ' '.repeat(indent + 2)
  const currentIndent = ' '.repeat(indent)
  return `{\n${entries.map(([key, entryValue]) => `${childIndent}${formatPropertyName(key)}: ${formatTsValue(entryValue, indent + 2)}`).join(',\n')}\n${currentIndent}}`
}
